import { NgModule } from "@angular/core";
import { CommonModule, DatePipe, TitleCasePipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { DeleteDialogComponent } from "./delete-dialog/delete-dialog.component";
import { ImageViewerModule } from "ng2-image-viewer";

// Dynamic Fields
import { ReadOnlyComponent } from "components/read-only/read-only.component";
import { InputComponent } from "components/input/input.component";
import { ButtonComponent } from "components/button/button.component";
import { SelectComponent } from "components/select/select.component";
import { DateComponent } from "components/date/date.component";
import { RadiobuttonComponent } from "components/radiobutton/radiobutton.component";
import { CheckboxComponent } from "components/checkbox/checkbox.component";
import { AttachFileComponent } from "components/attach-file/attach-file.component";
import { DynamicFieldDirective } from "components/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "components/dynamic-form/dynamic-form.component";

import { GlobalInputComponent } from "components/global-input/global.input.component";
import { GlobalTextareaComponent } from "components/global-textarea/global-textarea.component";
import { GlobalSelectComponent } from "components/global-select/global.select.component";
import { MediaUploadComponent } from "components/media-upload/media-upload.component";

import { FileInputComponent } from "components/file-input/file-input.component";
import { DownloadExcelComponent } from "components/download-excel/download-excel.component";

// Universal Material Table
import { MatTableComponent } from "components/mat-table/mat-table.component";
import { RowActionsComponent } from "components/row-actions/row-actions.component";

// Directives
import { DecimalDirective } from "directives/decimal.directive";
import { DragDropDirective } from "directives/drag-drop.directive";

// Pipes
import { UnderscorePipe } from "pipes/underscore.pipe";
import { IndianCurrencyPipe } from "pipes/indian-currency.pipe";
import { SafeStylePipe, SafeUrlPipe } from "pipes/safe.pipe";
import { IndStdNumberPipe } from "pipes/indian-number.pipe";
import { SafeHtmlPipe } from "pipes/safe-html.pipe";

import { MAT_DATE_LOCALE } from "@angular/material/core";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { ManufacturerRegistrationComponent } from "../registration/company-registration/manufacturer-registration/manufacturer-registration.component";
import { PageHeaderComponent } from "../commonModules/page-header/page-header.component";
import { ReactiveFormsModule } from "@angular/forms";

import "../stringExtensions";
import { MaterialModule } from "material.module";
import { RequiredMarkerComponent } from "components/required.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { ConfirmationDialogsComponent } from "./confirmation-dialogs/confirmation-dialogs.component";
import { AssignDialogComponent } from "./assign-dialog/assign-dialog.component";
import { AssignUserDialogComponent } from "./assign-user-dialog/assign-user-dialog.component";
import { TextareaComponent } from "components/textarea/textarea.component";
import { ToggleComponent } from "components/toggle/toggle.component";
import { SelectMultipleComponent } from "components/select-multiple/select-multiple.component";
import { InlineValidationDirective } from "directives/inline-validation.directive";
import { UpdatePasswordComponent } from "./update-password/update-password.component";
import { AddLandfillComponent } from "adminModules/city-facilities/landfill/add-landfill.component";
import { AddDumpsiteComponent } from "adminModules/city-facilities/dumpsite/add-dumpsite.component";
import { AddPlantComponent } from "adminModules/city-facilities/plant/add-plant.component";
import { SearchUlbComponent } from "components/search-ulb/search-ulb.component";
import { SelectAccessAreaComponent } from "components/select-access-area/select-access-area.component";
import { SelectAccessAreaAllstateComponent } from "components/select-access-area-allstate/select-access-area-allstate.component";
import { FilterListComponent } from "components/filter-list/filter-list.component";
import { MapContactComponent } from "components/map-contact/map-contact.component";
import { DistributionTableComponent } from "components/distribution-table/distribution-table.component";
import { AddContactComponent } from "adminModules/contact-management/add-contact.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CompleteProfileComponent } from "./complete-profile/complete-profile.component";
import { ManualsLinkComponent } from "./manuals-link/manuals-link.component";
import { BannerComponent } from "./banner/banner.component";
import { FormFooterComponent } from "components/form-footer/form-footer.component";
import { ItemBoxComponent } from "dashboard/box-item.component";
import { ExportComponent } from "components/export/export.component";
import { MakerCheckerComponent } from "./maker-checker/maker-checker.component";
import { DateMonthYearComponent } from "components/date-month-year/date-month-year.component";
import { YatradialoComponent } from "./yatradialo/yatradialo.component";
import { MultipleUlbComponent } from "components/multiple-ulb/multiple-ulb.component";
import { GlobalMultiSelectComponent } from "components/global-multi-select/global.multiselect.component";
import { ViewUploadComponent } from "components/view-upload/view-upload.component";
import { PlantListComponent } from "adminModules/city-facilities/plant/plant-list.component";
import { AlertMessageComponent } from "./alert-message-dialog/alert-message.component";
import { ViewPdfVideoComponent } from "./view-pdf-video/view-pdf-video.component";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatRadioModule } from "@angular/material/radio";
import { LoaderinnerComponent } from "components/loaderinner/loaderinner.component";
//import { CheckboxDialogComponent } from './checkbox-dialog/checkbox-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    PageHeaderComponent,
    FooterComponent,
    DecimalDirective,
    DragDropDirective,
    InlineValidationDirective,
    UnderscorePipe,
    IndianCurrencyPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    SafeUrlPipe,
    IndStdNumberPipe,
    DeleteDialogComponent,
    AlertMessageComponent,
    ManufacturerRegistrationComponent,
    RequiredMarkerComponent,
    MatTableComponent,
    RowActionsComponent,
    ItemBoxComponent,
    AddContactComponent,
    // Dynamic Fields & Form
    ReadOnlyComponent,
    InputComponent,
    ButtonComponent,
    SelectComponent,
    SelectMultipleComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    TextareaComponent,
    ToggleComponent,
    AttachFileComponent,
    ExportComponent,
    LoaderinnerComponent,
    FileInputComponent,
    DownloadExcelComponent,
    GlobalInputComponent,
    GlobalTextareaComponent,
    GlobalSelectComponent,
    GlobalMultiSelectComponent,
    DateMonthYearComponent,
    MediaUploadComponent,
    ViewUploadComponent,
    SearchUlbComponent,
    SelectAccessAreaComponent,
    MultipleUlbComponent,
    SelectAccessAreaAllstateComponent,
    FilterListComponent,
    MapContactComponent,
    DistributionTableComponent,

    DynamicFieldDirective,
    DynamicFormComponent,
    ConfirmationDialogComponent,
    ConfirmationDialogsComponent,
    AssignDialogComponent,
    AssignUserDialogComponent,
    UpdatePasswordComponent,
    AddLandfillComponent,
    AddDumpsiteComponent,
    AddPlantComponent,
    CompleteProfileComponent,
    ManualsLinkComponent,
    BannerComponent,
    FormFooterComponent,
    MakerCheckerComponent,
    YatradialoComponent,
    PlantListComponent,
    ViewPdfVideoComponent,
    //CheckBoxDialogComponent,
    //CheckboxDialogComponent
  ],
  entryComponents: [
    BannerComponent,
    ViewPdfVideoComponent,
    DeleteDialogComponent,
    AlertMessageComponent,
    ConfirmationDialogComponent,
    ConfirmationDialogsComponent,
    AssignDialogComponent,
    AssignUserDialogComponent,
    UpdatePasswordComponent,
    AddContactComponent,
    CompleteProfileComponent,

    // Dynamic Fields & Form
    ReadOnlyComponent,
    InputComponent,
    ButtonComponent,
    SelectComponent,
    SelectMultipleComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    TextareaComponent,
    ToggleComponent,
    AttachFileComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    DragDropModule,
    ImageViewerModule,
    NgxDocViewerModule,
    MatDatepickerModule
  ],
  exports: [
    LoaderinnerComponent,
    HeaderComponent,
    NgxDocViewerModule,
    FooterComponent,
    RequiredMarkerComponent,
    DecimalDirective,
    InlineValidationDirective,
    UnderscorePipe,
    IndianCurrencyPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    SafeUrlPipe,
    IndStdNumberPipe,
    PageHeaderComponent,
    ReactiveFormsModule,
    ManufacturerRegistrationComponent,
    MaterialModule,
    DragDropModule,
    MatTableComponent,
    RowActionsComponent,
    ItemBoxComponent,
    ExportComponent,
    FileInputComponent,
    DownloadExcelComponent,
    GlobalInputComponent,
    GlobalTextareaComponent,
    GlobalSelectComponent,
    GlobalMultiSelectComponent,
    DateMonthYearComponent,
    MediaUploadComponent,
    ViewUploadComponent,
    SearchUlbComponent,
    SelectAccessAreaComponent,
    MultipleUlbComponent,
    SelectAccessAreaAllstateComponent,
    FilterListComponent,
    MapContactComponent,
    DistributionTableComponent,
    UpdatePasswordComponent,
    DynamicFormComponent,
    AddLandfillComponent,
    AddDumpsiteComponent,
    AddPlantComponent,
    ManualsLinkComponent,
    FormFooterComponent,
    MakerCheckerComponent,
    PlantListComponent,
    MatRadioModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    UnderscorePipe,
    IndStdNumberPipe,
    TitleCasePipe,
    SafeStylePipe,
    SafeUrlPipe,
    DatePipe
  ],
})
export class SharedModule { }
